// 商品管理
export default [
  {
    path: "/product",
    meta: { title: "商品管理" },
    component: () => import("../views/product/index.vue"),
    children: [
      {
        path: "/product/all",
        meta: { title: "全部商品", isMenu: true },
        component: () => import("../views/product/all.vue"),
      },
      {
        path: "/product/detail/info",
        meta: { title: "商品详情" },
        component: () => import("../views/product/detail/info.vue"),
      },

      {
        path: "/product/category",
        meta: { title: "商品分类", isMenu: true },
        component: () => import("../views/product/category.vue"),
      },

      {
        path: "/product/feeSetting",
        meta: { title: "费用设置", isMenu: true },
        component: () => import("../views/product/feeSetting.vue"),
      },

      {
        path: "/product/shippingTemplate",
        meta: { title: "运费模板", isMenu: true },
        component: () => import("../views/product/shippingTemplate.vue"),
      },
      {
        path: "/product/detail/addTemplate",
        meta: { title: "新增模板" },
        component: () => import("../views/product/detail/addTemplate.vue"),
      },
      {
        path: "/product/detail/updateTemplate",
        meta: { title: "修改模板" },
        component: () => import("../views/product/detail/updateTemplate.vue"),
      },
      {
        path: "/product/detail/relatedProducts",
        meta: { title: "关联商品" },
        component: () => import("../views/product/detail/relatedProducts.vue"),
      },     
    ],
  },
]
